export default __webpack_public_path__ + "images/4a384cd86ac5d60a4ab5feb6ee4f8292-new_age_small.webp";